var React = require('react');

function PaginationArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"np_arrow_2153062_000000","d":"M38.9,39.922a.753.753,0,0,1-.755.748H7.5l4,3.964a.718.718,0,0,1,0,1.047.753.753,0,0,1-.529.223.743.743,0,0,1-.528-.225L5.162,40.445l-.113-.112a.132.132,0,0,1-.038-.074c0-.038-.038-.038-.038-.074s0-.038-.038-.074c0-.038,0-.038-.038-.074a.525.525,0,0,0,.04-.261c0-.038,0-.038.038-.074,0-.038,0-.038.038-.074,0-.038.038-.038.038-.074s.038-.038.038-.074l.113-.112,5.283-5.234a.734.734,0,0,1,1.057,0,.718.718,0,0,1,0,1.047l-4.04,4H38.141a.753.753,0,0,1,.755.748Z","transform":"translate(38.895 45.904) rotate(180)","fill":"#0000ff"}));
}

PaginationArrowRightInline.defaultProps = {"width":"34","height":"12","viewBox":"0 0 34 12"};

module.exports = PaginationArrowRightInline;

PaginationArrowRightInline.default = PaginationArrowRightInline;
